import React from "react";
import { Box, Typography, Container, IconButton } from "@mui/material";
import { Facebook, Twitter, Instagram } from "@mui/icons-material";
import { motion } from "framer-motion";

export default function Footer() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 60 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <Box sx={{ bgcolor: "#111", color: "white", py: 4 }}>
        <Container maxWidth="lg" sx={{ textAlign: "center" }}>
          <Typography variant="h6" gutterBottom>
            HealthTrackAI
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Monitor your kidney health with smart insights.
          </Typography>
          <Box>
            <IconButton href="#" sx={{ color: "white" }}>
              <Facebook />
            </IconButton>
            <IconButton href="#" sx={{ color: "white" }}>
              <Twitter />
            </IconButton>
            <IconButton href="#" sx={{ color: "white" }}>
              <Instagram />
            </IconButton>
          </Box>
          <Typography variant="caption" sx={{ mt: 2, display: "block" }}>
            © {new Date().getFullYear()} HealthTrackAI. All rights reserved.
          </Typography>
        </Container>
      </Box>
    </motion.div>
  );
}